import { writable } from "svelte/store";
import cartStore from "$lib/js/cart.js";

export const mobileMenuOpened = writable(false);
export const isLogged = writable(false);
export const cart = cartStore;

export const login = writable("");
export const email = writable("");
export const amount = writable(20);

export const donateMultiplayer = writable(1);
export const isBonus = writable(true);

export const selectStep = writable("register");
export const userEmail = writable("");

export const purchaseKind = writable(null);
export const purchaseId = writable(null);
export const purchaseTitle = writable("");
